import { render, staticRenderFns } from "./AppRolesUpdate.vue?vue&type=template&id=3a572fff&scoped=true&"
import script from "./AppRolesUpdate.vue?vue&type=script&lang=js&"
export * from "./AppRolesUpdate.vue?vue&type=script&lang=js&"
import style0 from "./AppRolesUpdate.vue?vue&type=style&index=0&id=3a572fff&prod&lang=scss&scoped=true&"
import style1 from "./AppRolesUpdate.vue?vue&type=style&index=1&id=3a572fff&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a572fff",
  null
  
)

export default component.exports